import React, { useState, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import ReactMarkdown from "react-markdown";

const GlobalWebsiteDisclaimer = () => {
  const navigate = useNavigate();
  const [markdownContent, setMarkdownContent] = useState("");

  // You can either:
  // 1. Import markdown as a string directly
  // 2. Fetch from a file (if placed in public folder)
  // 3. Use inline markdown content

  useEffect(() => {
    // Option 1: Fetch from public folder
    // fetch('/doc/Global Website Disclaimer.md')
    //     .then(res => res.text())
    //     .then(text => setMarkdownContent(text))
    //     .catch(err => console.error('Error loading markdown:', err));

    // Option 2: Use inline markdown (default example)
    setMarkdownContent(`
## **GLOBAL WEBSITE DISCLAIMER**

**Last Updated: October 23, 2025**

The information provided on this website and all related platforms operated by **JS TRADING VENTURES SDN. BHD.**, operating as **JS Tradventures** (“we”, “us”, or “our”), including but not limited to:

* [https://js-tradventures.com](https://js-tradventures.com)

* [https://jstradventures.co/](https://jstradventures.co/)

* [https://jstradventures.co/crypto-webinar/](https://jstradventures.co/crypto-webinar/)

* [https://jstradventures.co/gold-webinar/](https://jstradventures.co/gold-webinar/)

* All associated subdomains, landing pages, sales funnels, online registration pages, social media accounts, groups, communities, webinars, digital products, messaging channels, and content distribution platforms

(collectively referred to as the **“Platforms”**) is for **general informational and educational purposes only**.

By accessing or using our Platforms, you agree to the terms below.

---

### **No Financial, Investment, or Professional Advice**

All content provided is for **educational purposes only** and must not be considered financial, investing, legal, accounting, tax, or professional advice. Nothing on our Platforms constitutes:

* personalised advice

* a recommendation to buy, sell, or trade any financial product

* financial services or investment advisory activity

Always seek the guidance of a **licensed and qualified professional** in your jurisdiction before making financial decisions.

---

### **No Regulated Services Provided**

We are **not** licensed or registered by any financial regulator in Malaysia or internationally. We do not provide:

* investment advice

* brokerage or dealing services

* trading or execution services

* portfolio management

* financial planning services

This includes but is not limited to: Securities Commission Malaysia (SC), Monetary Authority of Singapore (MAS), U.S. Securities and Exchange Commission (SEC), Financial Conduct Authority UK (FCA), Australian Securities & Investments Commission (ASIC), European Securities and Markets Authority (ESMA), or any equivalent regulator worldwide.

---

### **Educational Content Only**

All examples, case studies, strategies, concepts, or references to financial markets (including crypto, forex, stocks, gold, commodities, or other instruments) are **hypothetical, generic, and for illustration only**.

They do not represent real results, and **you must not rely on them** for financial decisions.

---

### **No Guarantees of Results or Earnings**

We make **no guarantees of results**, performance, or income. Any testimonials, success stories, or experiences shared on our Platforms are individual results and are **not typical**.

Your success depends entirely on your own effort, skills, knowledge, risk tolerance, and market conditions.

---

### **User Responsibility & Risk Acknowledgement**

You are solely responsible for evaluating all information and making your own decisions. By using our Platforms, you acknowledge and agree that:

* trading, investing, and dealing in financial markets involve **high risks**, including the loss of capital

* past performance is **not** a guarantee of future results

* you assume **full responsibility and risk** for your actions

We are not liable for any losses, damages, or consequences arising from your reliance on information from our Platforms.

---

### **No Client Relationship Created**

Your use of our Platforms, purchasing our products, attending our webinars, or communicating with us **does not create a client relationship** between you and us.

---

### **Third-Party Content & Links**

Our Platforms may contain links or references to external websites, services, or third-party content. We do not control or endorse such content and are **not responsible** for any loss or damage from their use.

---

### **Accuracy & Completeness Disclaimer**

While we strive to provide accurate and up-to-date information, we make **no representation or warranty** regarding completeness, accuracy, or reliability. Content may change without notice.

---

### **Limitation of Liability**

To the fullest extent permitted by law, we disclaim all liability for any direct, indirect, incidental, consequential, or punitive damages arising in connection with your use of our Platforms.

If applicable law does not allow exclusion of certain damages, our maximum liability shall be limited to the lesser of:  
 (a) the total amount you paid to us in the last 30 days, or  
 (b) USD $50.

---

### **Changes to This Disclaimer**

We may update this Disclaimer from time to time without notice. Continued use of our Platforms indicates acceptance of any changes.

---

### **Contact Information**

For questions about this Disclaimer, contact:

**JS TRADING VENTURES SDN. BHD.**  
d/b/a **JS Tradventures**  
Email: contact@jstradventures.co  
Website: [https://js-tradventures.com](https://js-tradventures.com)
        `);
  }, []);

  return (
    <>
      <div className="flex justify-between items-center fixed top-0 left-0 w-screen h-auto backdrop-blur py-4 px-12 [&>div]:flex-1 [&>div]:w-full z-[100] max-[900px]:px-6">
        {/* NavBar Start */}
        <div className="flex gap-8 items-center [&>a]:transition-all [&>a]:underline [&>a]:underline-offset-4 [&>a:hover]:font-semibold max-[1000px]:hidden">
          <a href="/">Home</a>
          {/* <a href="#why">Why</a> */}
          {/* <a href="#member_testimonial">Testimonial</a> */}
          <Link className="text-nowrap" to="/contact-us">
            Contact Us
          </Link>
          <Link className="text-nowrap" to="#">
            Global Website Disclaimer
          </Link>
        </div>
        {/* NavBar Center */}
        <div className="flex-center max-[900px]:items-start">
          <h1 className="font-semibold text-lg">JS Tradventures</h1>
        </div>
        {/* NavBar End */}
        <div className="flex justify-end">
          <button
            className="text-gray-400 hover:text-gray-700 text-2xl font-bold focus:outline-none"
            aria-label="Close"
            onClick={() =>
              window.history.length > 1 ? navigate(-1) : navigate("/")
            }
          >
            &times;
          </button>
        </div>
      </div>
      <main className="relative flex-center gap-0 text-[14px] md:text-[16px] lg:text-[16px] space-y-16 pt-16">
        <div className="relative max-w-3xl mx-auto p-8 text-gray-800 bg-white rounded shadow">
          <div className="markdown-content">
            <ReactMarkdown
              components={{
                h1: ({ node, ...props }) => (
                  <h1 className="text-3xl font-bold mb-6" {...props} />
                ),
                h2: ({ node, ...props }) => (
                  <h2 className="text-2xl font-semibold mt-8 mb-4" {...props} />
                ),
                h3: ({ node, ...props }) => (
                  <h3 className="text-xl font-semibold mt-6 mb-2" {...props} />
                ),
                p: ({ node, ...props }) => <p className="mb-6" {...props} />,
                ul: ({ node, ...props }) => (
                  <ul
                    className="mb-6 space-y-2"
                    style={{ listStyle: "none", paddingLeft: 0 }}
                    {...props}
                  />
                ),
                ol: ({ node, ...props }) => (
                  <ol
                    className="list-decimal list-inside mb-6 space-y-2"
                    {...props}
                  />
                ),
                li: ({ node, ...props }) => (
                  <li
                    className="flex before:content-['•'] before:mr-2 before:text-gray-800"
                    style={{ listStyle: "none" }}
                    {...props}
                  />
                ),
                a: ({ node, ...props }) => (
                  <a className="text-blue-600 underline" {...props} />
                ),
                hr: ({ node, ...props }) => <hr className="my-8" {...props} />,
                strong: ({ node, ...props }) => (
                  <strong className="font-semibold" {...props} />
                ),
                em: ({ node, ...props }) => (
                  <em className="italic" {...props} />
                ),
              }}
            >
              {markdownContent}
            </ReactMarkdown>
          </div>
        </div>
        <div className="bg-black text-white w-full max-w-[98%] rounded-custom rounded-b-none p-12 grid grid-cols-2 justify-around items-center gap-4 max-[920px]:p-4 max-[920px]:py-12 max-[920px]:max-w-none !pb-24 relative">
          <div className="flex flex-col items-center md:items-start col-span-2 md:col-span-1">
            <h1 className="text-3xl font-semibold py-12">JS Tradventures</h1>
            <div className="text-sm opacity-80 text-center md:text-left">
              <p className="font-semibold">JS Trading Ventures Sdn Bhd</p>
              <p>No. 136-02, Jalan Adda 7,</p>
              <p>Taman Adda Heights,</p>
              <p>81100 Johor Bahru,</p>
              <p>Johor, Malaysia</p>
              <p>
                Email:{" "}
                <a
                  href="mailto:contact@jstradventures.co"
                  className="underline hover:font-semibold"
                >
                  contact@jstradventures.co
                </a>
              </p>
              <p>
                Phone:{" "}
                <a
                  href="tel:+60182662349"
                  className="underline hover:font-semibold"
                >
                  +60 18-266 2349
                </a>
              </p>
            </div>
          </div>
          <div className="flex flex-row min-w-[50%] justify-around gap-4 max-[768px]:min-w-full col-span-2 md:col-span-1">
            <div className="flex flex-col gap-2 [&>a]:underline [&>a]:underline-offset-4 [&>a]:pl-1 [&>a:hover]:font-semibold">
              <p className="font-semibold">Navigations</p>
              <a href="#home">Home</a>
              <a href="#why">Why Us</a>
              <a href="#benefit">Benefits</a>
              <a href="#member_testimonial">Testimonial</a>
              <a href="#timeline">Timeline</a>
              <a href="#community">Community</a>
              <Link to="/contact-us">Contact Us</Link>
              <Link to="/global-website-disclaimer">
                Global Website Disclaimer
              </Link>
            </div>
            <div className="flex flex-col gap-2 [&>a]:underline [&>a]:underline-offset-4 [&>a]:pl-1 [&>a:hover]:font-semibold">
              <p className="font-semibold">Contact Us</p>
              <a
                target="_BLANK"
                rel={"noreferrer"}
                href="https://discord.gg/9FBtyRpSHw"
              >
                Discord
              </a>
              <a
                target="_BLANK"
                rel={"noreferrer"}
                href="https://www.facebook.com/profile.php?id=61560315221726&mibextid=LQQJ4d"
              >
                Facebook
              </a>
              <a
                target="_BLANK"
                rel={"noreferrer"}
                href="https://www.instagram.com/jstradventures"
              >
                Instagram
              </a>
              <a
                target="_BLANK"
                rel={"noreferrer"}
                href="https://t.me/+h2HVoJhHT004ODA1"
              >
                Telegram
              </a>
              <a
                target="_BLANK"
                rel={"noreferrer"}
                href="https://www.threads.net/@jstradventures"
              >
                Threads
              </a>
              <a
                target="_BLANK"
                rel={"noreferrer"}
                href="https://x.com/JS_Tradventures"
              >
                X (Twitter)
              </a>
              <Link to="/contact-us">Get in Touch</Link>
            </div>
          </div>
          <div className="flex flex-row justify-center items-center opacity-80 flex-wrap text-nowrap col-span-2">
            <Link
              className="p-4 text-current font-light hover:font-bold underline"
              target="_blank"
              to="https://docs.google.com/document/d/13QELt1UIhHPAtrtkrehVy14JlQY10L5JToFUbZHOadw/edit?usp=sharing"
            >
              Privacy Policy
            </Link>
            <p></p>
            <Link
              className="p-4 text-current font-light hover:font-bold underline"
              target="_blank"
              to="https://docs.google.com/document/d/1RenzDKZR-s7O8kRtrCKY6Jq6-5SXAxqbRYB8H1Aasi8/edit?usp=sharing"
            >
              Terms and Conditions
            </Link>
            <Link
              className="p-4 text-current font-light hover:font-bold underline"
              target="_blank"
              to="https://docs.google.com/document/d/1zMrBKDqC4838_Iaud-Wk3Vin1TEfYmw4uPB2_XolPqc/edit?usp=sharing"
            >
              Risk Disclosure Statement
            </Link>
            <Link
              className="p-4 text-current font-light hover:font-bold underline"
              target="_blank"
              to="https://docs.google.com/document/d/1ycFzHFiJDjV9M2d7sFFXkAU1frFC2qxk1kk1-bmSET8/edit?usp=sharing"
            >
              Cookie Policy
            </Link>
          </div>
        </div>
      </main>
    </>
  );
};

export default GlobalWebsiteDisclaimer;
